import React, { useState, useEffect } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import BellSlashRegular from "../Icon/BellSlashRegular";
import Case_AdmissionAssessment_CheckRegular from "../Icon/Case_AdmissionAssessment_CheckRegular";
import Case_AdmissionAssessment_XmarkRegular from "../Icon/Case_AdmissionAssessment_XmarkRegular";
import Patient_CheckReferral_CheckRegular from "../Icon/Patient_CheckReferral_CheckRegular";
import Patient_CheckReferral_XmarkRegular from "../Icon/Patient_CheckReferral_XmarkRegular";
import Patient_AmbulanceDeparture_CheckRegular from "../Icon/Patient_AmbulanceDeparture_CheckRegular";
import Patient_AmbulanceDeparture_XmarkRegular from "../Icon/Patient_AmbulanceDeparture_XmarkRegular";
import Patient_ReportReferral_XmarkRegular from "../Icon/Patient_ReportReferral_XmarkRegular";
import Patient_ArrivalLanseed_CheckRegular from "../Icon/Patient_ArrivalLanseed_CheckRegular";
import Case_IAAssessment_CheckRegular from "../Icon/Case_IAAssessment_CheckRegular";
import Case_IAAssessment_XmarkRegular from "../Icon/Case_IAAssessment_XmarkRegular";
import ReasonModal from "../Modal/ReasonModal";
import SaveAlertModel from "../Modal/SaveAlertModel";

const Container = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0px;
  .title {
    padding: 15px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
  }
`;

function EditBodyProgress({
  progressData,
  CaseStatus,
  PatientStatus,
  rowId,
  hospital,
  caseCode,
  referralFeedback,
}) {
  //console.log(CaseStatus);
  //console.log(PatientStatus?.Code);
  //console.log(rowId);

  const resetData = progressData?.map((v, i) => {
    const { DateTime } = v;
    return {
      ...progressData[i],
      DateTime: dayjs(DateTime).format("YYYY/MM/DD HH:mm:ss"),
    };
  });
  //console.log(resetData);
  const [selfIdentities, setSelfIdentities] = useState([]);
  const [otherIdentities, setOtherIdentities] = useState([]);

  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonTitle, setReasonTitle] = useState("");

  useEffect(() => {
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
    setOtherIdentities(
      JSON.parse(localStorage.getItem("auth"))?.OtherIdentities
    );
  }, []);
  return (
    <Container>
      <div className="title">
        <div>轉診進度</div>
        <div
          style={{
            backgroundColor: "#f2f2f2",
            fontSize: "12px",
            padding: "5px",
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            marginLeft: "8px",
          }}
        >
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              marginRight: "2px",
              backgroundColor: `${CaseStatus?.HexColor}`,
            }}
          ></div>
          <div>{CaseStatus?.Name}</div>
        </div>
      </div>
      <div className="timeLineBox">
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
            },
          }}
        >
          {PatientStatus?.Code === 1 && CaseStatus?.Code === 2 ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 6px 0px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>
                  回覆收到通知
                </Typography>
                {selfIdentities && (
                  <Typography style={{ fontSize: "10px" }}>
                    <BellSlashRegular rowId={rowId} code={CaseStatus?.Code} />
                  </Typography>
                )}
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {PatientStatus?.Code === 1 && CaseStatus?.Code === 4 ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>收治評估?</Typography>
                {selfIdentities?.includes("tbc_doctor") ||
                selfIdentities?.includes("neurology") ? (
                  <Typography style={{ fontSize: "10px" }}>
                    <Case_AdmissionAssessment_CheckRegular
                      rowId={rowId}
                      code={CaseStatus?.Code}
                    />
                    <Case_AdmissionAssessment_XmarkRegular
                      rowId={rowId}
                      code={CaseStatus?.Code}
                    />
                  </Typography>
                ) : (
                  <></>
                )}
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {PatientStatus?.Code === 2 && CaseStatus?.Code === 5 ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>確認轉診?</Typography>
                {otherIdentities && (
                  <Typography style={{ fontSize: "10px" }}>
                    <Patient_CheckReferral_CheckRegular
                      rowId={rowId}
                      code={PatientStatus?.Code}
                      caseCode={caseCode}
                      hospital={hospital}
                    />
                    <Patient_CheckReferral_XmarkRegular
                      rowId={rowId}
                      code={PatientStatus?.Code}
                      caseCode={caseCode}
                      hospital={hospital}
                    />
                  </Typography>
                )}
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {PatientStatus?.Code === 3 && CaseStatus?.Code === 5 ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>
                  救護車出發?
                </Typography>
                {otherIdentities && (
                  <Typography style={{ fontSize: "10px" }}>
                    <Patient_AmbulanceDeparture_CheckRegular
                      rowId={rowId}
                      code={PatientStatus?.Code}
                      caseCode={caseCode}
                      hospital={hospital}
                      time={dayjs(new Date()).format("YYYY/MM/DD HH:mm")}
                    />
                    <Patient_ReportReferral_XmarkRegular
                      rowId={rowId}
                      code={PatientStatus.Code}
                    />
                  </Typography>
                )}
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {PatientStatus?.Code === 4 && CaseStatus?.Code === 5 ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>抵達聯新?</Typography>
                {selfIdentities?.includes("neurology") && (
                  <Typography style={{ fontSize: "10px" }}>
                    <Patient_ArrivalLanseed_CheckRegular
                      rowId={rowId}
                      code={PatientStatus?.Code}
                      caseCode={caseCode}
                      hospital={hospital}
                    />
                  </Typography>
                )}
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {PatientStatus?.Code === 5 && CaseStatus?.Code === 7 ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>IA評估</Typography>
                {selfIdentities && (
                  <Typography style={{ fontSize: "10px" }}>
                    <Case_IAAssessment_CheckRegular
                      rowId={rowId}
                      code={CaseStatus?.Code}
                      caseCode={caseCode}
                    />
                    <Case_IAAssessment_XmarkRegular
                      rowId={rowId}
                      code={CaseStatus?.Code}
                      caseCode={caseCode}
                    />
                  </Typography>
                )}
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {PatientStatus?.Code === 5 && CaseStatus?.Code === 8 ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>啟動IA中</Typography>
                {selfIdentities?.includes("tbc_doctor") &&
                selfIdentities?.includes("nurse") ? (
                  <Typography style={{ fontSize: "10px" }}>
                    <Case_AdmissionAssessment_CheckRegular />
                    <Case_AdmissionAssessment_XmarkRegular />
                  </Typography>
                ) : (
                  <></>
                )}
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {PatientStatus?.Code === 5 &&
          CaseStatus?.Code === 10 &&
          referralFeedback === null ? (
            <TimelineItem style={{ minHeight: "initial" }}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                <Typography style={{ fontSize: "14px" }}>Now</Typography>
                <Typography style={{ fontSize: "16px" }}>轉診回饋</Typography>
              </TimelineContent>
            </TimelineItem>
          ) : (
            <></>
          )}
          {resetData?.map((v, i) => {
            return (
              <TimelineItem key={i} style={{ minHeight: "initial" }}>
                <TimelineSeparator>
                  <TimelineDot />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent style={{ padding: "6px 16px 0px 6px" }}>
                  <Typography style={{ fontSize: "14px" }}>
                    {v.DateTime}
                  </Typography>
                  <Typography style={{ fontSize: "16px" }}>
                    {v.CreateUser}:
                    <span
                      style={{
                        color:
                          (v.Name === "取消轉診" ||
                            v.Name === "不收治" ||
                            v.Name === "不需IA") &&
                          v.Reason !== null
                            ? "#057aff"
                            : "#252525",
                        cursor:
                          (v.Name === "取消轉診" ||
                            v.Name === "不收治" ||
                            v.Name === "不需IA") &&
                          v.Reason !== null
                            ? "pointer"
                            : "",
                      }}
                      onClick={() => {
                        if (
                          (v.Name === "取消轉診" ||
                            v.Name === "不收治" ||
                            v.Name === "不需IA") &&
                          v.Reason !== null
                        ) {
                          setReasonTitle(v.Name);
                          setReason(v.Reason);
                          setOpen(true);
                        }
                      }}
                    >
                      {v.Name}
                    </span>
                  </Typography>
                  <ReasonModal
                    open={open}
                    setOpen={setOpen}
                    reason={reason}
                    reasonTitle={reasonTitle}
                  />
                </TimelineContent>
              </TimelineItem>
            );
          })}
        </Timeline>
      </div>
      <SaveAlertModel />
    </Container>
  );
}

export default EditBodyProgress;
